var map = {
  "./cs.json": [
    "Ja",
    [
      "js"
    ]
  ],
  "./en.json": [
    "qu5",
    [
      "wq"
    ]
  ],
  "./pl.json": [
    "FuR",
    [
      "br"
    ]
  ],
  "./ru.json": [
    "v0",
    [
      "hb"
    ]
  ],
  "./tr.json": [
    "Kj",
    [
      "ok"
    ]
  ],
  "./ja.json": [
    "FKk",
    [
      "3f"
    ]
  ],
  "./zh.json": [
    "qgJ",
    [
      "sl"
    ]
  ],
  "./pt-br.json": [
    "s6",
    [
      "a2d"
    ]
  ],
  "./de.json": [
    "oOR",
    [
      "2pw"
    ]
  ],
  "./es.json": [
    "Na",
    [
      "7s"
    ]
  ],
  "./fr.json": [
    "MTR",
    [
      "mb"
    ]
  ],
  "./it.json": [
    "HA",
    [
      "dd"
    ]
  ],
  "./ko.json": [
    "nQ",
    [
      "t0"
    ]
  ],
  "./pt.json": [
    "wQU",
    [
      "ma3f"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "YN";
module.exports = __rspack_async_context;
